import { Button, Link, LinkProps, Typography } from "@mui/material";
import { HTMLAttributeAnchorTarget, ReactNode } from "react";

/**
 * リンクテキスト。SCLinkと違い、外部サイトへのリンクが可能。
 * href の代わりに onClick を指定すると、遷移ではなく処理を実行するボタンとして動作する。
 */
export type ExternalLinkProps = {
  children: ReactNode;
  href?: LinkProps["href"];
  target?: HTMLAttributeAnchorTarget;
  onClick?: () => void;
};
export function ExternalLink({
  children,
  href,
  target,
  onClick,
}: ExternalLinkProps) {
  const anchorTarget = target ?? "_self";
  const linkProps =
    href != null ? { component: Link, href, target: anchorTarget } : {};

  return (
    <Button
      variant="text"
      {...linkProps}
      onClick={onClick}
      sx={{
        p: 0,
        color: "white",
        textDecoration: "none",
        // display: blockを指定しないと、inline-flexが自動で指定される。inline-flexだと、リンク(テキスト)の左右にスペースが設けられて、レイアウト崩れの原因になる。
        display: "block",
      }}
    >
      <Typography variant="caption" color="white">
        {children}
      </Typography>
    </Button>
  );
}
